"use client"

import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react"
import { useTheme } from "next-themes"
import { Toaster as Sonner, type ToasterProps } from "sonner"

// Sonner only understands light/dark/system, so brand themes map to their base.
const DARK_THEMES = new Set(["dark", "custom-dark"])

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()
  const sonnerTheme: ToasterProps["theme"] =
    theme === "system" ? "system" : DARK_THEMES.has(theme) ? "dark" : "light"

  return (
    <Sonner
      theme={sonnerTheme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:border group-[.toaster]:shadow-lg group-[.toaster]:rounded-lg group-[.toaster]:p-4 group-[.toaster]:gap-3 group-[.toaster]:w-full group-[.toaster]:min-w-[360px] group-[.toaster]:max-w-[420px]",
          description: "group-[.toast]:text-sm group-[.toast]:leading-relaxed group-[.toast]:opacity-80",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground group-[.toast]:hover:bg-primary/90 group-[.toast]:rounded-md group-[.toast]:px-3 group-[.toast]:py-1.5 group-[.toast]:text-sm group-[.toast]:font-medium group-[.toast]:transition-colors",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground group-[.toast]:hover:bg-muted/80 group-[.toast]:rounded-md group-[.toast]:px-3 group-[.toast]:py-1.5 group-[.toast]:text-sm group-[.toast]:font-medium group-[.toast]:transition-colors",
          title: "group-[.toast]:text-sm group-[.toast]:font-semibold",
          icon: "group-[.toast]:mr-0",
          closeButton: "group-[.toast]:border group-[.toast]:rounded-md group-[.toast]:transition-colors",
        },
      }}
      icons={{
        success: <CircleCheckIcon className="h-5 w-5 text-green-600 dark:text-green-500" />,
        info: <InfoIcon className="h-5 w-5 text-blue-600 dark:text-blue-500" />,
        warning: <TriangleAlertIcon className="h-5 w-5 text-amber-600 dark:text-amber-500" />,
        error: <OctagonXIcon className="h-5 w-5 text-red-600 dark:text-red-500" />,
        loading: <Loader2Icon className="h-5 w-5 animate-spin" />,
      }}
      {...props}
    />
  )
}

export { Toaster }
